import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ErrorModal, SuccessModal } from "@components";
import { Table } from "@pentabd/ui";

import { TableColumn } from "./AnnualBudgetPlanDetailsTableColumn";

import { useNavigate } from "react-router-dom";
// import useActionCreator from "@redux/hooks/useActionCreator";
import { usePackageList } from "@hooks/procurements/package/usePackages";
import { PackagesResponseType } from "@type/procurements/package";
import { Pagination } from "@type/procurements/pagination";
import useCustomSelector from "@redux/hooks/useCustomSelector";

export const AnnualBudgetPlanDetailsTable = ({
  id,
}: {
  id: number | string;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // const { packageDeleteActionHandler } = useActionCreator();

  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);

  const { handleQuery, packageState } = usePackageList(id);

  const { getData } = packageState;

  const { data, pagination } = getData || ({} as PackagesResponseType);
  const { page, total, size } = pagination || ({} as Pagination);

  const { deleteSuccess, deleteError } = useCustomSelector(
    (store) => store.procurements.packageState,
  );

  const createSuccessAction = () => {
    setIsSuccessModalOpen(false);
    handleQuery("page", page);
  };

  const closeErrorModal = () => {
    setIsErrorModalOpen(false);
  };

  useEffect(() => {
    if (deleteSuccess) {
      setIsSuccessModalOpen(true);
    } else if (!!deleteError) {
      setIsErrorModalOpen(true);
    }
  }, [deleteSuccess, deleteError]);

  return (
    <>
      {/* modals  */}
      {isSuccessModalOpen && (
        <SuccessModal
          isModalOpen={isSuccessModalOpen}
          action={createSuccessAction}
        />
      )}
      {isErrorModalOpen && (
        <ErrorModal
          isModalOpen={isErrorModalOpen}
          closeModal={closeErrorModal}
        />
      )}
      {/* modal ends */}
      <Table
        header={{
          title: "Packages",
        }}
        columns={TableColumn(t, navigate)}
        // actions={[
        //   {
        //     customIcon: (
        //       <Button type="light" size="sm" fill="outline">
        //         {t("PROCUREMENT_ANNUAL_PLAN.TABLE.ACTIONS.DETAILS_BUTTON_TEXT")}
        //       </Button>
        //     ),
        //     onClick: (id) => {
        //       navigate(`${id}`);
        //     },
        //   },
        // ]}
        rows={data}
        pagination={{
          totalPage: Math.ceil(total / size),
          onClick: (currentPage) => handleQuery("page", currentPage),
          activePage: page,
        }}
      />
    </>
  );
};
